import { AwsConfig } from './Constants';
import BasePaginationQuery from '../interfaces/base-pagination-query';
import BaseService, { RequestInterface } from './Base';
import IPagination from '../interfaces/IPagination';


export default class UserGroupService extends BaseService {

  constructor() {
    super(AwsConfig.API_CONFIG, 'user-group');
  }

  async paging(query: BasePaginationQuery, fields?: string[]): Promise<IPagination<any>> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    if (query.unit) {
      params.queryStringParameters['unit'] = query.unit;
    }
    if (query.notUnit) {
      params.queryStringParameters['notUnit'] = query.notUnit;
    }
    if (query.notRole) {
      params.queryStringParameters['notRole'] = query.notRole;
    }
    if (query.haveManager) {
      params.queryStringParameters['haveManager'] = query.haveManager;
    }
    if (query.hasRole) {
      params.queryStringParameters['hasRole'] = query.hasRole;
    }
    if (query.pillar) {
      params.queryStringParameters['pillar'] = query.pillar;
    }
    if (query.limit) {
      params.queryStringParameters['limit'] = query.limit;
    }
    if (query.offset) {
      params.queryStringParameters['offset'] = query.offset;
    }
    if (query.disabled != null) {
      params.queryStringParameters['disabled'] = query.disabled;
    }
    if (query.search) {
      params.queryStringParameters['search'] = query.search;
    }
    if (query.noAuditor) {
      params.queryStringParameters['noAuditor'] = query.noAuditor;
    }
    if (query.noAudited) {
      params.queryStringParameters['noAudited'] = query.noAudited;
    }
    if (query.noAssignment) {
      params.queryStringParameters['noAssignment'] = query.noAssignment;
    }
    if (query.isManager != null) {
      params.queryStringParameters['isManager'] = query.isManager;
    }

    const res = await super.get<IPagination<any>>('', params);
    return res;
  }
  async getById(id: string, fields?: string[]): Promise<any> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    const res = await super.get<any>(id, params);
    return res;
  }
  async create(data: any): Promise<any> {
    const params: RequestInterface = {
      body: data
    };
    const res = await super.post<any>('', params);
    return res;
  }

  async updateById(id: string, data: any): Promise<any> {
    const params: RequestInterface = {
      body: data
    };
    const res = await super.put<any>(id, params);
    return res;
  }
  async deleteById(id: string): Promise<void> {
    await super.delete<void>(id);
  }
}

